import { render, staticRenderFns } from "./workOrderMgt.vue?vue&type=template&id=63362ecf&scoped=true&"
import script from "./workOrderMgt.vue?vue&type=script&lang=js&"
export * from "./workOrderMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63362ecf",
  null
  
)

export default component.exports